import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import * as actions from "../store/actions";

import "./AdminLogin.scss";

const LoginSchema = Yup.object().shape({
    email: Yup.string()
        .email("Invalid email.")
        .required("The email is required."),
    password: Yup.string().required("The passoword is required.")
});

const AdminLogin = ({ signIn, loading, error, cleanUp }) => {
    return (
        <div className="user">
            <Formik
                initialValues={{
                    email: "",
                    password: ""
                }}
                validationSchema={LoginSchema}
                onSubmit={async (values, actions) => {
                    await signIn(values);
                    actions.setSubmitting(false);
                }}
                render={({ isSubmitting, isValid }) => (
                    <Form className="form">
                        <div className="form__group">
                            <Field
                                type="email"
                                name="email"
                                placeholder="Your email..."
                                className="form__input"
                            />
                        </div>
                        <div className="form__group">
                            <Field
                                type="password"
                                name="password"
                                placeholder="Your password..."
                                className="form__input"
                            />
                        </div>

                        <button
                            className="btn"
                            type="submit"
                            disabled={!isValid || isSubmitting}
                        >
                            Login
                        </button>
                    </Form>
                )}
            />
        </div>
    );
};

const mapStateToProps = ({ auth }) => ({
    loading: auth.loading,
    error: auth.error
});

const mapDispatchToProps = {
    signIn: actions.signIn,
    cleanUp: actions.clean
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminLogin);
